/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */
import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.css";
import { NUMBER, MISSED_CALL_CHECK_INTERVAL } from "../../../constants/app-constants";
import PropTypes from "prop-types";
import TransparentButton from "../button/transparent-button";
import Button from "../button";
import InputText from "../input-text";
import CountdownTimer from "../countdown-timer";
// import CloseButton from "../icon-cross";
// import ArrowIcon from "../arrow";
import BookingOtpRevamp from "../../desktop/booking-otp-revamp";

// eslint-disable-next-line complexity
const BookingOtp = ({
    isError,
    errorMessage,
    mobile,
    close,
    onChangeComplete = () => { },
    resendOTP,
    showSpinner,
    isMissCallEnabled = true,
    maxResentCount = NUMBER.SIX,
    changeNumber = true,
    isRevamped = false,
    onOtpChange = () => {},
    mobileNumber = "",
    customHeading = "",
    isEditable = false,
    showClose = true,
    otpLength
    // displayType
}) => {
    const otpInput = useRef();
    const [otp, setOTP] = useState("");
    const [canSubmitOtp, setCanSubmitOtp] = useState(false);
    const [counter, setCounter] = useState(0);
    const [resentOtp, setResentOtp] = useState(false);
    const [resentCount, setResentCount] = useState(0);
    const [showLoader, setShowLoader] = useState(true);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (resentOtp) {
            window.setTimeout(() => {
                setResentOtp(false);
                setShowLoader(false);
            }, MISSED_CALL_CHECK_INTERVAL);
        }
    }, [resentOtp, setShowLoader]);

    useEffect(() => {
        if (counter < NUMBER.THREE && isMissCallEnabled) {
            intervalRef.current = window.setInterval(() => {
                setCounter(c => c + 1);
                onChangeComplete("", true);
            }, MISSED_CALL_CHECK_INTERVAL);
        }
        return () => window.clearInterval(intervalRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [counter]);

    const resetOtp = () => {
        setOTP("");
    };

    useEffect(() => {
        if (isRevamped && !!errorMessage && otpInput && otpInput.current) {
            resetOtp();
            otpInput.current.focus();
        } else if (!isRevamped && otpInput && otpInput.current) {
            window.setTimeout(() => otpInput.current.focus(), 50);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorMessage, otpInput]);

    const resendOtpHandler = () => {
        resetOtp();
        setResentCount(resentCount + 1);
        if (resentCount < maxResentCount) {
            resendOTP();
            setResentOtp(true);
            setShowLoader(true);
        }
    };

    const onCompleteTimer = () => {
        setShowLoader(false);
    };

    const onChangeHandler = (e) => {
        const { target: { value } } = e;
        if (value === "" || !isNaN(value)) {
            setOTP(value);
            onOtpChange(value);
            setCanSubmitOtp(value.length === (otpLength || NUMBER.FOUR));
        }
    };

    const onSingularOtpChange = (number) => {
        setOTP(number);
        onOtpChange(number);
        setCanSubmitOtp(number.length === (otpLength || NUMBER.FOUR));
    };

    const onClickVerify = () => {
        if (otp && otp.length === otpLength) {
            onChangeComplete(otp);
        }
    };

    if (isRevamped) {
        return (
            <BookingOtpRevamp
                mobileNumber={mobileNumber}
                errorMessage={errorMessage}
                mobile={mobile}
                close={close}
                onChangeComplete={onClickVerify}
                resendOTP={resendOTP}
                showSpinner={showSpinner}
                isMissCallEnabled={isMissCallEnabled}
                maxResentCount={maxResentCount}
                changeNumber={changeNumber}
                showLoader={showLoader}
                resendOtpHandler={resendOtpHandler}
                onCompleteTimer={onCompleteTimer}
                otpInput={otpInput}
                otp={otp}
                onSingularOtpChange={onSingularOtpChange}
                resetOtp={resetOtp}
                customHeading={customHeading}
                isEditable={isEditable}
                showClose={showClose}
                otpLength={otpLength}
            />
        );
    } else {
        return (
            <div styleName={"styles.mainWrap"}>

                <div styleName={"styles.otpScreen"}>
                    <h4>Verify One Time Password (OTP)</h4>
                    <p>Please enter the 4 digit OTP sent to mobile no.</p>
                    {changeNumber && <div styleName={"styles.otpText"}>
                        {mobileNumber || mobile}
                        <span onClick={close}>Change Number</span>
                    </div>}
                    <div className={"form-group"} styleName={"styles.inputOtp"}>
                        <InputText
                            inputRef={otpInput}
                            text="Enter OTP"
                            onChange={onChangeHandler}
                            value={otp}
                            maxLength={4}
                            type={"tel"}
                        />
                        {
                            !showLoader &&
                        <span onClick={resendOtpHandler} styleName={`${(resentOtp || (!resentOtp &&
                            resentCount > maxResentCount)) ? "styles.disabled " : ""}`}>
                                Resend OTP
                        </span>
                        }
                        {
                            showLoader &&
                        <CountdownTimer interval={30} onComplete={onCompleteTimer} />
                        }
                        {isError &&
                        <div styleName={"styles.error"}>
                            {
                                errorMessage
                                    ?
                                    errorMessage
                                    :
                                    "Error! Please retry by entering correct OTP"
                            }
                        </div>}
                    </div>

                    <div styleName={"styles.buttonWrap"}>
                        <span styleName={"styles.transparent"}>
                            <TransparentButton text="CANCEL" onClick={close} />
                        </span>
                        <span styleName={"styles.blockButton"}>
                            <Button
                                text="VERIFY"
                                disabled={!canSubmitOtp}
                                onClick={onClickVerify}
                                isLoading={showSpinner}
                            />
                        </span>
                    </div>
                    {
                        isMissCallEnabled &&
                    <div styleName={"styles.orText"}>
                        <span>or</span>
                    </div>
                    }
                    {
                        (resentCount > NUMBER.SIX) &&
                    <span
                        styleName={"styles.error"}>You have reached maximum OTP limit</span>}
                    {
                        isMissCallEnabled &&
                    <div styleName={"styles.callText"}>
                        <p styleName={"styles.content"}>To verify instantly, <br/> Just give us a missed call on</p>
                        <a href="tel:+919015977711">+91 9015977711</a>
                    </div>
                    }
                </div>
            </div>
        );
    }
};

BookingOtp.propTypes = {
    isError: PropTypes.bool,
    errorMessage: PropTypes.string,
    onChangeComplete: PropTypes.func,
    mobile: PropTypes.string,
    close: PropTypes.func,
    resendOTP: PropTypes.func,
    showSpinner: PropTypes.bool,
    displayType: PropTypes.string,
    isMissCallEnabled: PropTypes.bool,
    maxResentCount: PropTypes.number,
    changeNumber: PropTypes.bool,
    isRevamped: PropTypes.bool,
    onOtpChange: PropTypes.func,
    mobileNumber: PropTypes.string,
    customHeading: PropTypes.string,
    isEditable: PropTypes.bool,
    showClose: PropTypes.bool,
    otpLength: PropTypes.number
};

export default BookingOtp;
